import { render, staticRenderFns } from "./novaBroad.vue?vue&type=template&id=49146b80"
import script from "./novaBroad.vue?vue&type=script&lang=js"
export * from "./novaBroad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports